import smsService from "../services/sms.service";

const sms = {
    namespaced: true,
    state: {
        debitOrderDates: null,
        bankAccountTypes: null,
    },
    actions: {
        //READ
        getsmsreplyaction(_, params) {
            return smsService.getsmsreplyaction(params.id, params.urlParameters, params.requestId);
        },

        getsmsunmatchedreplyaction(_, params) {
            return smsService.getsmsunmatchedreplyaction(params.id, params.urlParameters, params.requestId);
        },
    },
};

export default sms;
